"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeProp = exports.setStyledProps = void 0;

var _reduce2 = _interopRequireDefault(require("lodash/reduce"));

var _pull4 = _interopRequireDefault(require("lodash/pull"));

var _omitBy2 = _interopRequireDefault(require("lodash/omitBy"));

var _omit2 = _interopRequireDefault(require("lodash/omit"));

var _kebabCase2 = _interopRequireDefault(require("lodash/kebabCase"));

var _isNil2 = _interopRequireDefault(require("lodash/isNil"));

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _intersection2 = _interopRequireDefault(require("lodash/intersection"));

var _initial2 = _interopRequireDefault(require("lodash/initial"));

var _head2 = _interopRequireDefault(require("lodash/head"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _camelCase2 = _interopRequireDefault(require("lodash/camelCase"));

var _styledComponents = require("styled-components");

var _breakpoints = require("./breakpoints");

var _responsive = require("./responsive");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * Directions properties.
 */


var directions = {
  horizontal: ['left', 'right'],
  vertical: ['bottom', 'top']
};
/**
 * Omissible DOM properties.
 */

var omissibleDOMProps = ['as', 'children', 'className', 'forwardedComponent', 'forwardedRef', 'href', 'id', 'ref', 'style', 'theme'];
/**
 * Omit event handlers.
 */

function omitEventHandlers(props) {
  return (0, _omitBy2.default)(props, function (value, key) {
    return /^on[A-Z][a-zA-Z]+$/.test(key);
  });
}
/**
 * Get first element in arrays intersection.
 */


function getIntersectionFirstElement(first, second, defaultUnmatched) {
  var matches = (0, _intersection2.default)(first, second);
  return matches.length ? (0, _head2.default)(matches) : defaultUnmatched;
}
/**
 * Convert camel case string to array of strings.
 */


var camelCaseToArray = function camelCaseToArray(properties) {
  return (0, _kebabCase2.default)(properties).split('-');
};
/**
 * Create directional styles.
 */


function createDirectionalStyles(property, value, directions) {
  return directions.reduce(function (style, direction) {
    return _objectSpread({}, style, _defineProperty({}, "".concat(property, "-").concat(direction), value));
  }, {});
}
/**
 * Get styles by breakpoint.
 *
 * This method creates an object with the properties agregated by breakpoint.
 * It also creates the directional fields if provided by prop.
 */


function getStylesByBreakpoint(properties, orderedBreakpoints) {
  return Object.keys(properties).map(camelCaseToArray).reduce(function (group, item) {
    var value = (0, _get2.default)(properties, (0, _camelCase2.default)(item.toString()));

    if ((0, _isNil2.default)(value)) {
      return group;
    }

    var breakpoint = getIntersectionFirstElement(item, orderedBreakpoints, _breakpoints.baseBreakpoint);
    var propertiesArray = breakpoint === _breakpoints.baseBreakpoint ? item : (0, _initial2.default)(item);
    var property = (0, _kebabCase2.default)(propertiesArray.toString());
    var directionalFields = Object.keys(directions);
    var direction = getIntersectionFirstElement(item, directionalFields, false);

    var styleProps = _defineProperty({}, property, value); // Mutate `styleProps` with directions styles if `direction` is provided.


    if (direction) {
      var _pull2 = _pull4.default.apply(void 0, [item, direction].concat(_toConsumableArray(orderedBreakpoints))),
          _pull3 = _slicedToArray(_pull2, 1),
          _property = _pull3[0];

      var propDirections = (0, _get2.default)(directions, direction);
      styleProps = createDirectionalStyles(_property, value, propDirections);
    }

    return _objectSpread({}, group, _defineProperty({}, breakpoint, _objectSpread({}, group[breakpoint], styleProps)));
  }, {});
}
/**
 * Render style object to styled string.
 */


function renderToStyle(styleObject, breakpoint) {
  var style = (0, _reduce2.default)(styleObject, function (result, value, key) {
    return [].concat(_toConsumableArray(result), _toConsumableArray((0, _styledComponents.css)(["", ":", ";"], key, value)));
  }, []);

  if (!breakpoint) {
    return (0, _styledComponents.css)(["", ""], style);
  }

  return _responsive.media.min(breakpoint)(_templateObject(), style);
}
/**
 * Export `setStyledProps`.
 */


var setStyledProps = function setStyledProps(props) {
  var propsToOmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var breakpoints = (0, _get2.default)(props, 'theme.breakpoints');

  if (!breakpoints) {
    throw new Error("\uD83D\uDEA8 No breakpoints provided to the theme configuration.");
  }

  var orderedBreakpoints = (0, _breakpoints.orderedBreakpointsKeys)(breakpoints);
  var styleProps = omitEventHandlers((0, _omit2.default)(props, [].concat(omissibleDOMProps, _toConsumableArray(propsToOmit))));
  var stylesByBreakpoint = getStylesByBreakpoint(styleProps, orderedBreakpoints);
  return orderedBreakpoints.reduce(function (previousStyle, key) {
    var breakpoint = key !== _breakpoints.baseBreakpoint ? key : null;
    var styleBreakpoint = (0, _get2.default)(stylesByBreakpoint, key);

    if (!styleBreakpoint) {
      return previousStyle;
    }

    return [].concat(_toConsumableArray(previousStyle), _toConsumableArray(renderToStyle(styleBreakpoint, breakpoint)));
  }, []);
};
/**
 * Export `themeProp`.
 */


exports.setStyledProps = setStyledProps;

var themeProp = function themeProp(prop) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return function (props) {
    var themeProperty = (0, _get2.default)(props.theme, prop);
    return (0, _isFunction2.default)(themeProperty) ? themeProperty.apply(void 0, args) : themeProperty;
  };
};

exports.themeProp = themeProp;